import { DELIVERY_INDEX_STATUS } from '../constants/constants'

export function getDeliveryIndexDocumentId(model) {
  if (!model) return ''
  return String(model.uid || model.delivery_reference || model.db_ref || '').trim()
}

const entregasPath = (encodedDocumentId, status) => {
  const base = `/entregas/${encodedDocumentId}`
  return status ? `${base}?status=${encodeURIComponent(status)}` : base
}

export function buildDeliveryIndexDetailUrl(model) {
  const documentId = getDeliveryIndexDocumentId(model)
  if (!documentId) return null

  const encodedDocumentId = encodeURIComponent(documentId)
  const { status } = model

  switch (status) {
    case DELIVERY_INDEX_STATUS.REFUND:
    case DELIVERY_INDEX_STATUS.PRESALE_REFUND:
      return `/devoluciones/${encodedDocumentId}`

    case DELIVERY_INDEX_STATUS.DELIVERY_RECEIPT:
    case DELIVERY_INDEX_STATUS.PARTIAL_DELIVERY_RECEIPT:
    case DELIVERY_INDEX_STATUS.PRE_SALE:
      return entregasPath(encodedDocumentId)

    default:
      return entregasPath(encodedDocumentId, status)
  }
}

export function openDeliveryIndexDetail(model, openFn = window.open.bind(window)) {
  const url = buildDeliveryIndexDetailUrl(model)
  if (!url) return
  openFn(url, '_blank')
}
